var b = Object.defineProperty, f = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var m = (e, o, r) => o in e ? b(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, a = (e, o) => {
  for (var r in o || (o = {}))
    s.call(o, r) && m(e, r, o[r]);
  if (t)
    for (var r of t(o))
      c.call(o, r) && m(e, r, o[r]);
  return e;
}, i = (e, o) => f(e, p(o));
import l, { forwardRef as g } from "react";
import n from "../lib/IconBase.mjs";
import d from "../defs/DribbbleLogo.mjs";
const w = g((e, o) => /* @__PURE__ */ l.createElement(n, i(a({ ref: o }, e), { weights: d })));
w.displayName = "DribbbleLogo";
export {
  w as DribbbleLogo
};
